export default __webpack_public_path__ + "static/11-7237a8c0244f492635832ce9f29a1e4a.jpg";